<div class="label-value-input slider">
    <div class="element-label minor">
        <div class="input-label">Units:</div>
        <div class="input-value-container">
            <nb-select [(selected)]="selectedUom" [placeholder]="selectedUom"  (selectedChange)="changeUom($event)" size="tiny" #narrowSelect>
                <nb-option *ngFor="let uom of uoms" [value]="uom">{{ uom.name }}</nb-option>
            </nb-select>
        </div>
    </div>
    <div class="element-label">
        <div class="input-label">All:</div>
        <div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueAll"></div>
    </div>
    <div class="custom-slider element-value">
        <ngx-slider #valueSlider [options]="options" [formControl]="sliderControl" (userChangeEnd)="sliderUserChangeEnd($event)"></ngx-slider>
    </div>
    <div class="element-label">
        <div class="input-label">Top:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueTop" (ngModelChange)="onIndividualValueChange($event)"></div>
    </div>
    <div class="element-label">
        <div class="input-label">Right:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueRight"  (ngModelChange)="onIndividualValueChange($event)"></div>
    </div>
    <div class="element-label">
        <div class="input-label">Bottom:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueBottom"  (ngModelChange)="onIndividualValueChange($event)"></div>
    </div>
    <div class="element-label">
        <div class="input-label">Left:</div><div class="input-value-container"><input class="input-value" nbInput fieldSize="tiny" type="number" [(ngModel)]="valueLeft" (ngModelChange)="onIndividualValueChange($event)"></div>
    </div>
</div>


